import(/* webpackMode: "eager" */ "/Users/dz151/Documents/telia/lt-telia-web-apps/apps/PublicWeb/app/global-error.tsx");
